import LocalizedStrings from 'react-localization';
 
 const strings = new LocalizedStrings({
 en:{

   meta_lang:'en',
   title_take_order:"Take order",
   title_take_order_close:"Location closed",
   message_take_order:"Activate order taking service and let your users send you digital orders.",
   message_take_order_close:"We have finished our day for today, tomorrow we will be available at our regular opening times.",
   title_not_found:"404", 
   message_not_found:"Location not found", 
   title_erro:"Error",
   message_not_order_active: '{0} has not yet activated the order taking service.', 
   
   title_summary:"Order summary",
   quantity:"Quantity", 
   price:"Price", 
   total:"Total", 
   id_item:"Id-Item", 
   title_order: "Location/shop", 
   meta_description: "Website to make orders through Wikimenu.",
   meta_title:"Taking order",
   message_not_content:"There is no content",

   // actions 
   action_cancel:"Cancel",
   action_next:"Next", 
   action_confirm:"Confirm",
   action_order:"Review and order", 
   action_back: "Back",
   action_order: "Send order",

   order_delivery:"Delivery order",
   order_takeaway:"Takeaway order",

   help_place: "e.g. Street a 56, Av parallel... etc",   
   help_details:"e.g. Apart 5, flat 3, #2 etc..", 
   address_page_title: "Search the delivery address", 
   delivery_fee: "Delivery area",
   delivery_extra: "Distance surcharge",
   error_out_of_range: "The maximum delivery distance is ${store}km and the current address is $ {user}km.",

   message_checkout_ok: "We will launch Whatsapp so you can send the order.",
   message_checkout_error: "We have not been able to process your order, please check your connection and try again.",
   action_send_to_whatsapp: "Send with Whatsapp", 
   action_done: "Done", 
   title_send: "Send order", 
   title_wait: "Order sent", 
   message_done: "Has the order been sent correctly or do you need to try again?", 
   delivery_to: "Deliver to", 
   message_home: "There is no store selected, please add the ID",

   hint_seach_addrees: "Seach your address",
   hint_details: "Address details",
   delivery_price_no_include:"The delivery price is not included here.",
   title_list_address:"Saved addresses",

   title_payment_options: "Payment method", 
   message_payment_select: "Select your preferred payment method", 
   message_payment_only:   "Only ${method} is accepted", 
  
   paymethod_cash: "Cash",
   paymethod_card: "Card",
   delivery_address:  "Delivery address",
   
   action_view_more: "View more",
   delivery_go_to_webapp:"Click here to order by Whatsapp.", 
   ticket_private_info:"This content is private, if you are the recipient of this order please open the link with the latest Wikimenu version.",
   ticket_title:"Order #",
   ticket_waiting_confirmationt:"If you have not yet sent the confirmation link through Whatsapp, please try again and wait for the answer.",
   image_open_with:"open_with_en.png", 

   ticket_request_pending:"The order is pending for confirmation of ${location}.",
   ticket_request_pending_local:"The order has been sent, we will begin processing it shortly.",
   ticket_request_reviewed:"Your order is being reviewed and will be confirmed soon",
   ticket_request_link:"If you were unable to send the order link, please retry %s or send us the link directly to:",
   ticket_request_cooking: "Your order has been accepted and is in preparation",
   ticket_request_delivering:"The courier is on the way",
   ticket_request_ready:"The order is prepared and ready for pickup.",
   ticket_request_delivered: "The order has been delivered",
   ticket_request_rejected: "The order has been rejected, for more details contact to ${location}",
   ticket_request_wait_payment_info:"We will display the payment information after the order is accepted",
  
   pickup_address: "Pickup address", 
   action_request: "Request service", 

   order_demo_info:"ATTENTION: This is a test order, after integrating WhatsApp, you will be able to configure the information requested to your client, such as, delivery address and payment method. Also, you will be able for set the delivery rates according to your preferences.",
  
   additions_max_options:"Select maximum ${maxOptions} options",
   additions_required:"Required",
   additions_add_for: "Add for ${price}",


   map_coordinates:  "Map coordinates",
   action_adjust: "Adjust",
   no_coordinates: "No coordinates",
   help_ajust_coordinates: "Move the map to point the red circle at the entrance of your building.", 
   powered_by: "Create your digital menu and delivery website with",

   paymethod_cash_change_label: "How much change do we carry?",
   paymethod_cash_change_for:   "Change for:",
   paymethod_cash_no_change:"Not change",
   paymethod_pay_with:"Pay with:",
   
   client_data_title:"Contact information",
   client_name:"Name",
   client_phone:"Phone",
   client_message_hint:"Observations and other delivery instructions",
   client_message_label: "Observations",

   payment_link: "Payment link", 
   copied_clipboard: "Copied to clipboard",
   delivery_label:"Delivery", 
   takeaway_label:"Pickup", 

   order_local:"Self-order",
   message_checkout_local: "Submit your order and we will process it soon.",
  

  },

 es:{
  meta_lang:'es',
  title_take_order:"Pedidos por WhatsApp",
  title_take_order_close:"Local Cerrado",
  message_take_order:"Activa el servicio de toma de pedidos y permite que tus usuarios envíen sus pedidos a través de whatsApp.",
  message_take_order_close:"Hemos finalizado nuestra jornada por el día de hoy, mañana estaremos disponibles en nuestro horario habitual.",
  title_not_found:"404", 
  message_not_found:"Negocio no encontrado.", 
  title_erro:"Error",
  message_not_order_active: '{0} aún no ha activado el servicio de toma de pedidos.',
  title_summary:"Resumen del Pedido",
 
  quantity:"Cantidad",
  price:"Precio",
  total:"Total",
  id_item:"Id-Item",
  title_order: "Establecimiento", 
  meta_description:"WebApp para realizar pedidos a través de Wikimenu.",
  meta_title:"Tomar el Pedido",
  message_not_content:"No hay contenido",
  //Actions 
  action_order:"Revisar y Pedir",
  action_cancel:"Cancelar",
  action_next:"Continuar",
  action_confirm:"Confirmar",
  action_back: "Atrás",
  action_order: "Enviar orden",

  order_delivery:"Entrega a domicilio",
  order_takeaway:"Recogida en el local",

  help_place: "Por ejemplo: Calle rosas 56, Av parallel 10",   
  help_details:"Por ejemplo: Apt 5, piso 3, #2 etc..", 
  address_page_title: "Busca La dirección de entrega", 
  delivery_fee: "Delivery zona",
  delivery_extra: "Recargo",
  error_out_of_range: "La distancia máxima de entrega es de ${store}Km y la dirección actual está a ${user}Km.",

  message_checkout_ok: "A continuación, lanzaremos WhatsApp para que puedas enviar el pedido.",
  message_checkout_error:"No hemos podido procesar tu pedido, por favor revisa tu conexion e intenta de nuevo.",
  action_send_to_whatsapp: "Enviar con WhatsApp", 
  action_done: "Hecho", 
  title_send: "Enviar Pedido", 
  title_wait: "Pedido Enviado", 
  message_done: "¿El pedido ha sido enviado correctamente o necesitas intentar de nuevo?", 
  delivery_to: "Entregar a:", 
  message_home: "No hay una tienda seleccionada, agregue el Id",
  hint_seach_addrees: "Busque la calle y número",
  hint_details: "Detalles de la dirección",
  delivery_price_no_include:"El precio del envío no está incluido.", 
  title_list_address:"Direcciones Guardadas",

  title_payment_options:  "Método de pago",
  message_payment_select: "Selecciona el método de pago", 
  message_payment_only:   "Sólo se acepta ${method}",
  paymethod_cash: "Dinero en efectivo",
  paymethod_card: "Tarjeta",
  delivery_address:  "Dirección entrega",
  action_view_more: "Ver mas...",
  delivery_go_to_webapp:"Haga click aquí para ordenar por WhatsApp.",
  ticket_private_info:"Este contenido es privado, si eres el destinatario de este pedido, abre el enlace con la última versión de Wikimenu.",
  ticket_title:"Pedido #",
  ticket_waiting_confirmationt:"Si todavía no has enviado el enlace de confirmacion a traves de whatsapp, por favor intenta de nuevo y espera la respuesta.",
  image_open_with:"open_with_es.png",

  ticket_request_pending:"El pedido está pendiente de confirmación por parte de ${location}.",
  ticket_request_pending_local:"En un momento comenzamos a preparar tu pedido.",
  ticket_request_reviewed:"Tu pedido está siendo revisado y pronto será confirmado",
  ticket_request_link:"Si no has podido enviar el enlace del pedido, por favor reintenta %s o envíanos el enlace directamente a:",
  ticket_request_cooking: "Tu pedido ha sido aceptado y se está preparando",
  ticket_request_delivering:"El repartidor está en camino.",
  ticket_request_ready:"El pedido esta preparado y listo para ser recogido.",
  ticket_request_delivered: "El pedido ha sido entregado",
  ticket_request_rejected: "El pedido ha sido rechazado, para más detalles contacta a ${location}",
  ticket_request_wait_payment_info:"Mostraremos la información de pago después de que el pedido sea aceptado",

  
  pickup_address: "Dirección de recogida",
  action_request: "Pedir servicio",
  order_demo_info:"ATENCIÓN: Este es un pedido de prueba, luego de integrar WhatsApp, podrás configurar la información solicitada a tu cliente, como dirección de entrega y forma de pago. Además, podrás establecer las tarifas de envío según tus preferencias.",

  additions_max_options:"Selecciona máximo ${maxOptions} opciones",
  additions_required:"Requerido",
  additions_add_for: "Añadir por ${price}",

  map_coordinates:  "Coordenadas del mapa",
  action_adjust: "Ajustar",
  no_coordinates: "Sin coordenadas",
  help_ajust_coordinates: "Mueva el mapa para apuntar el círculo rojo a la entrada de su edificio.", 
  powered_by: "Crea tu menú digital y web de delivery con",

  paymethod_cash_change_label: "¿LLevamos cambio?",
  paymethod_cash_change_for:   "Cambio para:",
  paymethod_cash_no_change:"No es necesario",
  paymethod_pay_with:"Pago con:",

  client_data_title:"Información de contacto",
  client_name:"Nombre",
  client_phone:"Telefono",
  client_message_hint:"Observaciones y otras instrucciones de entrega",
  client_message_label: "Observaciones",

  payment_link: "Enlace de pago", 
  copied_clipboard: "Copiado al porta papeles",

  delivery_label:"Delivery", 
  takeaway_label:"Recogida",

  order_local:"Auto-pedido",
  message_checkout_local: "Completa el proceso enviando tu pedido.",
  
},

pt:{
  meta_lang:'pt',
  title_take_order:"Realizar Pedido",
  title_take_order_close:"Loja fechado",
  message_take_order:"Ative a opção Realizar Pedido para permitir aos clientes realizar o pedido.",
  message_take_order_close:"Não estamos atendendo hoje, amanhã estaremos à disposição em nossa programação normal.",
  title_not_found:"404",
  message_not_found:"Local não encontrado.",
  title_erro:"Error",
  message_not_order_active: '{0} ainda não ativou o serviço de recebimento de pedidos.',
  title_summary:"Resumo do Pedido",
  quantity:"Quantidade",
  price:"Preço",
  total:"Total",
  id_item:"Id-Item",
  title_order: "Estabelecimento",
  meta_description:"Página para pedidos através do Wikimenu.",
  meta_title:"Realizar Pedido",
  message_not_content:"Não há conteúdo",
  
  // nuevas ---------------------------------------------------------
  action_back: "Voltar",
  action_cancel:"Cancelar",
  action_next:"Próximo",
  action_order:"Revisar e Pedir",
  action_confirm:"Confirmar",
  action_order: "Enviar pedido",
  order_delivery:"Entrega a domicilio",
  order_takeaway:"Recolher na loja",
  
  help_place: "Ej: Calle rosas 56, Av parallel..etc",
  help_details:"Ej: Apart 5, piso 3, #2 etc..",
  address_page_title: "Pesquise o endereço de entrega",
  delivery_fee: "Delivery zona",
  delivery_extra: "Adicional de distância",
  error_out_of_range: "A distância máxima de entrega é ${store}Km e o endereço atual é ${user}Km.",
  
  message_checkout_ok: "Vamos abrir o WhatsApp para você concluir o pedido.",
  message_checkout_error:"Não foi possível processar seu pedido, verifique sua conexão e tente novamente.",
  action_send_to_whatsapp: "Enviar WhatsApp",
  action_done: "Concluído!",
  title_send: "Enviar Pedido",
  title_wait: "Pedido Enviado!",
  message_done: "O pedido foi enviado corretamente ou você precisa tentar novamente?",
  delivery_to: "Entregar a:", 
  message_home: "Nenhuma loja selecionada, adicione ID",
  hint_seach_addrees: "Pesquise o endereço",
  hint_details: "Detalhes do Endereço",
  delivery_price_no_include:"O preço de envio não está incluído aqui.",
  title_list_address:"Endereços salvos", 

  title_payment_options: "Forma de pagamento",
  message_payment_select: "Selecione o seu método de pagamento", 
  message_payment_only:   "Apenas pagamento com ${method}",
  paymethod_cash: "Dinheiro",
  paymethod_card: "Cartão",
  delivery_address:  "Endereço",
  action_view_more: "Ver mais...",
  delivery_go_to_webapp:"Clique aqui para perdir por WhatsApp.", 

  ticket_private_info:"Este conteúdo é privado, se você for o destinatário deste pedido, por favor, abra o link com a última versão do Wikimenu.",
  ticket_title:"Pedido #", 
  ticket_waiting_confirmationt:"Se você ainda não enviou o link de confirmação pelo whatsapp, tente novamente e aguarde a resposta.",
  image_open_with:"open_with_pt.png",

  ticket_request_pending:"O pedido está pendente de confirmação por parte de ${location}.",
  ticket_request_pending_local:"O pedido foi enviado, em alguns instantes iniciaremos o processamento.",
  ticket_request_reviewed:"Seu pedido está sendo analisado e será confirmado em breve.",
  ticket_request_link:"Se não for possível enviar o link do pedido, por favor, tente novamente %s ou envie o link diretamente para:",
  ticket_request_cooking: "Seu pedido foi aceito e está sendo preparado",
  ticket_request_delivering:"O entregador está a caminho",
  ticket_request_ready:"O pedido está preparado e pronto para ser retirado.",
  ticket_request_delivered: "O pedido foi entregue",
  ticket_request_rejected: "O pedido foi rejeitado, para mais detalhes converse com ${location}",
  ticket_request_wait_payment_info:"Mostraremos as informações de pagamento após o pedido ser aceito",

  pickup_address: "Endereço de retirada", 
  action_request: "Pedir serviço",
  order_demo_info:"ATENÇÃO: Este é um pedido teste, após integrar o WhatsApp, você poderá configurar as informações solicitadas ao seu cliente, como endereço de entrega e forma de pagamento. Além disso, você poderá definir as taxas de entrega de acordo com suas preferências.",
  
  additions_max_options:"Selecione no máximo ${maxOptions} opções",
  additions_required:"Obrigatório",
  additions_add_for: "Adicionar por ${price}",

  map_coordinates:  "Coordenadas do mapa",
  action_adjust: "Ajustar",
  no_coordinates: "Sem coordenadas",
  help_ajust_coordinates: "Mova o mapa para apontar o círculo vermelho na entrada do seu prédio.",
  powered_by: "Crie seu cardápio digital e web de delivery com",


  paymethod_cash_change_label: "Precisa de troco? ",
  paymethod_cash_change_for:   "Troco para:",
  paymethod_cash_no_change:  "Não precisa",
  paymethod_pay_with:"Pago com:",

  client_data_title:"Informações de contato",
   client_name:"Nome",
   client_phone:"Telefone",
   client_message_hint:"Observações e outras instruções de entrega",
   client_message_label: "Observações",

   payment_link: "Link de pagamento", 
   copied_clipboard: "Copiado para a área de transferência",

   delivery_label:"Delivery", 
   takeaway_label:"Retirada",

   order_local:"Auto-pedido",
   message_checkout_local: "Conclua o processo enviando seu pedido.",
  },


});

export default strings; 

